"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CheckBox_v2", {
  enumerable: true,
  get: function get() {
    return _CheckBox_v.default;
  }
});

var _CheckBox_v = _interopRequireDefault(require("./CheckBox_v2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }